<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="40"
      strokeWidth="3"
    ></mat-progress-spinner>
  </div>

  <form
    class="card-form"
    style="display: flex; height: 100%; flex-direction: column"
    [formGroup]="motorForm"
    (ngSubmit)="submitForm()"
    novalidate
  >
    <div class="blue-top"></div>
    <div
      class="card-section top-section"
      style="position: relative; display: flex; flex: 1; flex-direction: column"
    >
      <h1>
        <b>{{ pageHeading }} </b>
      </h1>
      <h2>{{ pageSubheading }}</h2>

      <mat-form-field
        appearance="outline"
        class="form-select"
        style="flex: none"
      >
        <textarea
          matInput
          placeholder="{{ damageInfoLabel }}"
          formControlName="damageInfo"
          style="height: 70px"
          (blur)="logErrors()"
        ></textarea>
        <mat-error *ngIf="formErrors['damageInfo']"
          >{{ formErrors["damageInfo"] }}
        </mat-error>
      </mat-form-field>

      <!-- <p>{{ othersDamagedQuestion }}</p>
      <section class="row-div modified_checkbox" formGroupName="othersDamaged">
        <div class="row-inner-div row-inner-div-left">
          <mat-checkbox formControlName="yes" (change)="onYesChange()"
            >{{ yesText }}
          </mat-checkbox>
        </div>
        <div class="row-inner-div row-inner-div-right">
          <mat-checkbox formControlName="no" (change)="onNoChange()"
            >{{ noText }}
          </mat-checkbox>
        </div>
      </section>
      <mat-error *ngIf="formGroupErrors['othersDamaged']"
        >{{ formGroupErrors["othersDamaged"] }}
      </mat-error>

      <div
        *ngIf="
          motorForm.controls['othersDamaged'].controls['yes'].value === true
        "
        class="width-100pc"
      >
        <div formArrayName="extra">
          <div *ngFor="let entry of getEntries().controls; let i=index" [formGroupName]="i">
  
            <div class="row-div-reverse remove-stroked-button" *ngIf="i > 0">
              <button mat-stroked-button type="button" (click)="removeEntry(i)">
                <span class="button-text">{{ remove }}</span>
              </button>
            </div>

            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
              <mat-label class="form-select-placeholder-unselected"
                >{{ ownerNameLabel }}
              </mat-label>
              <input matInput formControlName="ownerName" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['ownerName']"
                >{{ formErrors["ownerName"] }}
              </mat-error>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
              <mat-label class="form-select-placeholder-unselected"
                >{{ ownerAddressLabel }}
              </mat-label>
              <input matInput formControlName="ownerAddress" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['ownerAddress']"
                >{{ formErrors["ownerAddress"] }}
              </mat-error>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
              <mat-label class="form-select-placeholder-unselected"
                >{{ insurerNameLabel }}
              </mat-label>
              <input matInput formControlName="insurerName" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['insurerName']"
                >{{ formErrors["insurerName"] }}
              </mat-error>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
              <mat-label class="form-select-placeholder-unselected"
                >{{ policyNumLabel }}
              </mat-label>
              <input matInput formControlName="policyNum" (blur)="logErrors()" />
              <mat-error *ngIf="formErrors['policyNum']"
                >{{ formErrors["policyNum"] }}
              </mat-error>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
              <mat-label class="form-select-placeholder-unselected"
                >{{ otherDriverNameLabel }}
              </mat-label>
              <input
                matInput
                formControlName="otherDriverName"
                (blur)="logErrors()"
              />
              <mat-error *ngIf="formErrors['otherDriverName']"
                >{{ formErrors["otherDriverName"] }}
              </mat-error>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
              <mat-label class="form-select-placeholder-unselected"
                >{{ otherDriverNumLabel }}
              </mat-label>
              <input
                matInput
                formControlName="otherDriverNum"
                (blur)="logErrors()"
              />
              <mat-error *ngIf="formErrors['otherDriverNum']"
                >{{ formErrors["otherDriverNum"] }}
              </mat-error>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
              <textarea
                matInput
                placeholder="{{ otherPropertyDamagedLabel }}"
                formControlName="otherPropertyDamaged"
                style="height: 70px;"
                (blur)="logErrors()"
              ></textarea>
              <mat-error *ngIf="formErrors['otherPropertyDamaged']"
                >{{ formErrors["otherPropertyDamaged"] }}
              </mat-error>
            </mat-form-field>
  
            <div class="divider-line"></div>
          </div>
        </div>
  
        BUTTTON aDD carInvolved
        <div class="row-div general-stroked-button">
          <button mat-stroked-button type="button" (click)="addNewEntry()">
            <span class="button-text">+&nbsp;&nbsp;{{ addmoreCarsLabel }}</span>
          </button>
        </div>
      </div>

       <div class="row-div margin-bottom-40" style="margin-top: 70px;" *ngIf="motorForm.controls['othersDamaged'].controls['yes'].value === true">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{ cancelText }} </span>
        </button>
        <button mat-button type="submit" [disabled]="!motorForm.valid">
          <span class="button-text">{{ saveText }} </span>
        </button>
      </div> -->

      <div
        *ngIf="
          !(motorForm.controls['othersDamaged'].controls['yes'].value === true)
        "
        style="
          position: absolute;
          bottom: 40px;
          left: 0px;
          right: 0px;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="row-div"
          style="
            align-items: center;
            width: 90%;
            margin-left: 5%;
            margin-right: 5%;
          "
        >
          <button mat-stroked-button type="button" (click)="confirmCancel()">
            <span class="button-text">{{ cancelText }}</span>
          </button>
          <button mat-button type="submit" [disabled]="!motorForm.valid">
            <span class="button-text">{{ saveText }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
